module.exports = __webpack_public_path__ + "static/media/multibanco.svg.6cdd5e69.png";